import React, { useEffect, useState } from "react";

import styled from "styled-components";
import Context from "../Context";

import {
  Typo,
  ProgressBar,
  Flex,
  ContentContainer,
  Button,
  Div,
  Line,
  Container,
  Grid,
  CouponCard,
  LoadingIcon,
} from "../components";
import provinces from "../constants/province.json";
import { deliverChannels, devices, validate } from "../constants";
import { Modal } from "reactstrap";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import themes from "../themes";
import { FaCheck } from "react-icons/fa";
import { Collapse } from "reactstrap";
import { bankList, roundDateToDate } from "../util";
export const Cart = () => {
  const {
    callApi,
    configs,
    profileState,
    toast,
    go,
    sessions,
    setCart,
    cart,
    hideModalLoading,
  } = Context();
  // const affiliate = sessionStorage.getItem("affiliate");

  const [cartData, setCartData] = useState([]);

  const [deliverChannel, setDeliverChannel] = useState("");
  const [myCoupon, setMyCoupon] = useState([]);
  const [modal, setModal] = useState(false);
  const [removeNumber, setRemoveNumber] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState({});

  const [showConsent, setShowConsent] = useState(false);
  const [acceptConsent, setAcceptConsent] = useState(false);

  // let isValidAffiliate = profileState.userNo !== affiliate;

  // if (!configs.isAffiliateOpen) {
  //   isValidAffiliate = false;
  // }

  const [isBuyForSomeoneElse, setIsBuyForSomeoneElse] = useState(false);
  const [orderBody, setOrderBody] = useState({
    firstName: profileState.firstName || "",
    lastName: profileState.lastName || "",
    phone: profileState.phone || "",
    bank: profileState.bank || {},
    isGuest: localStorage.guestId ? true : false,
    guestId: localStorage.guestId || "",
    referrer:
      sessionStorage.referrer === profileState.referrer
        ? profileState.referrer
        : "",

    //  isAffiliate: !!affiliate ? isValidAffiliate : false,
    //  affiliateId: !!affiliate ? (isValidAffiliate ? affiliate : false) : false,
    utm: {
      status: localStorage.getItem("utm_status") === "true",
      utm_source: localStorage.getItem("utm_source") || false,
      utm_medium: localStorage.getItem("utm_medium") || false,
      utm_campaign: localStorage.getItem("utm_campaign") || false,
      utm_createdAt: localStorage.getItem("utm_createdAt") || false,
    },
  });

  const toggle = () => setModal(!modal);

  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      hideModalLoading();
      if (localStorage.accessToken) {
        // await callApi("coupons-validateExpireCouponByUserId");
        // const calPrice = await callApi("utils-calculatePrice");
        // const result = await callApi("carts-getCart");
        // const myCoupon = await callApi("coupons-getTransactionByUserId");
        const localStoragSelectedCouponId =
          localStorage.getItem("selectedCouponId");

        await Promise.all([
          callApi(
            "coupons-validateExpireCouponByUserId",
            {},
            { notShowLoading: true }
          ),
          callApi("utils-calculatePrice", {}, { notShowLoading: true }),
          callApi(
            "coupons-getAvailableCouponByUserId",
            {},
            { notShowLoading: true }
          ),
        ]).then(async ([validCoupon, cartData, myCoupon]) => {
          if (cartData.totalSize === 0 || !cartData) {
            return go("/");
          }
          if (cartData.deliverChannel === "online") {
            setIsBuyForSomeoneElse(
              (!localStorage.guestId &&
                sessionStorage.getItem("sendAsAGift")) ||
                false
            );
          } else if (!cartData.deliverChannel) {
            go("/deliverChannel");
          }

          if (
            localStoragSelectedCouponId &&
            cart.deliverChannel === deliverChannels.online
          ) {
            const getCouponById = myCoupon.data.filter(
              (coup) => coup.id === localStoragSelectedCouponId
            )[0];

            if (getCouponById?.id) {
              const result = await callApi("carts-injectCoupon", {
                coupon: getCouponById.id,
              });
              if (result) {
                localStorage.removeItem("selectedCouponId");
                setSelectedCoupon(getCouponById);
                recalculatePrice();
              }
            }
          } else if (cartData.coupon) {
            setSelectedCoupon(cartData.coupon);
          }

          const myAvailableCoupon = myCoupon.data.filter(
            (coup) => coup.coupon.type !== "reserve"
          );
          localStorage.removeItem("selectedCouponId");

          setDeliverChannel(cartData.deliverChannel);
          setMyCoupon(myAvailableCoupon);
          setCartData(cartData);
        });
      } else if (localStorage.guestId) {
        // setIsShowOTP(true);
        const cartData = await callApi(
          "utils-calculatePrice",
          {
            guestId: localStorage.guestId,
          },
          { notShowLoading: true }
        );

        if (!cartData?.otp?.status) {
          go("/verify-cart");
        }

        if (cartData.totalSize === 0 || !cartData) {
          return go("/");
        }

        if (!cartData.deliverChannel) {
          go("/deliverChannel");
        }
        setTimeout(() => {
          setDeliverChannel(cartData.deliverChannel);
          setCartData(cartData);
        }, 5000);
      } else {
        go("/register");
      }
    })(); // eslint-disable-next-line
  }, [cart]);

  const recalculatePrice = async () => {
    const result = await callApi("utils-calculatePrice");
    if (result.deliverChannel === "online") {
      setIsBuyForSomeoneElse(
        (!localStorage.guestId && sessionStorage.getItem("sendAsAGift")) ||
          false
      );
    }
    setDeliverChannel(result.deliverChannel);
    setCartData(result);
  };

  const handleRemove = (number) => {
    setRemoveNumber(number);
    setModal(true);
  };

  const removeCart = async (number) => {
    const showCart = await callApi("carts-removeOneLotto", {
      number,
      guestId: localStorage.guestId || false,
    });
    // if (!Object.keys(showCart).length) {
    //   return go("/");
    // }
    setCart(showCart);
    setModal(false);
  };

  const createOrder = async () => {
    // let updateBody = {
    //   ...orderBody,
    // };
    // if (sessions.influencer) {
    //   updateBody.influencer = sessions.influencer;
    // }
    const result = await callApi("orders-createOrder", {
      ...orderBody,
      isBuyForSomeoneElse,
    });

    if (result.orderId) {
      if (deliverChannel === "offline") {
        go("/status/pending_offline");

        setCart({ size: 0, expireIn: 0 });
      }
      localStorage.removeItem("utm_status");
      localStorage.removeItem("utm_source");
      localStorage.removeItem("utm_medium");
      localStorage.removeItem("utm_campaign");
      localStorage.removeItem("utm_createdAt");
      localStorage.removeItem("sendAsAGift");
      sessionStorage.removeItem("referrer");
      setCart({ size: 0, expireIn: 0 });
      go(`/payment/${result.orderId}`);
    } else {
      result.error && toast(result.error);
      go("/");
    }
  };

  const handleSetSelectCoupon = async (id) => {
    if (id === selectedCoupon?.id) {
      const result = await callApi("carts-ejectCoupon");
      if (result) {
        setSelectedCoupon({});
        recalculatePrice();
      }
    } else {
      const getCouponById = myCoupon.filter((coup) => coup.id === id)[0];

      const result = await callApi("carts-injectCoupon", {
        coupon: getCouponById.id,
      });
      if (result) {
        setSelectedCoupon(getCouponById);
        recalculatePrice();
      }
    }
  };

  return (
    <Flex direction="column" margin="0 0 30px 0" width="100%">
      <Modal isOpen={modal} toggle={toggle} centered>
        <ContentContainer padding="20px" minHeight="0px">
          <Flex direction="column" align="center">
            <Div width="45px" height="50px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 20"
                fill="none"
                style={{ width: "100%" }}
              >
                <path
                  d="M6 1C6 0.447715 6.44772 0 7 0H11C11.5523 0 12 0.447715 12 1V2H17C17.5523 2 18 2.44772 18 3C18 3.55228 17.5523 4 17 4H1C0.447716 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H6V1Z"
                  fill="#D60B0B"
                />
                <path
                  d="M3 6C3.55228 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H13C13.5523 18 14 17.5523 14 17V7C14 6.44772 14.4477 6 15 6C15.5523 6 16 6.44772 16 7V17C16 18.6569 14.6569 20 13 20H5C3.34315 20 2 18.6569 2 17V7C2 6.44772 2.44772 6 3 6Z"
                  fill="#D60B0B"
                />
                <path
                  d="M6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9V15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V9Z"
                  fill="#D60B0B"
                />
                <path
                  d="M11 8C10.4477 8 10 8.44772 10 9V15C10 15.5523 10.4477 16 11 16C11.5523 16 12 15.5523 12 15V9C12 8.44772 11.5523 8 11 8Z"
                  fill="#D60B0B"
                />
              </svg>
            </Div>
            <Typo.H7 color="navy" margin="20px">
              ต้องการลบสลาก ?
            </Typo.H7>
            <Flex gap="5px" justify="center" width="100%">
              <Typo.Body3
                color="textBlack"
                wrap="balance"
                textAlign="center"
                lineHeight="1.5em"
              >
                คุณต้องการนำลอตเตอรี่
                <br />
                <span style={{ color: themes.colors.navy }}>
                  หมายเลข{" "}
                  {removeNumber?.toString().includes("magicBlock")
                    ? `${removeNumber?.split("-")[1]} (${
                        configs.magicNumber.name
                      })`
                    : removeNumber?.toString().includes("labubuBlock")
                    ? `${removeNumber?.split("-")[1]} (เลขลาบูบู้)`
                    : removeNumber}
                </span>{" "}
                <br />
                ออกจากตะกร้า ใช่หรือไม่?
              </Typo.Body3>
            </Flex>

            <Flex
              margin="20px 0 0 0"
              justify="space-between"
              width="100%"
              gap="20px"
            >
              <Button
                onClick={() => {
                  toggle();
                  setRemoveNumber();
                }}
                border="navy"
                color="navy"
                width="100%"
              >
                ยกเลิก
              </Button>
              <Button
                onClick={async () => {
                  await removeCart(removeNumber);
                }}
                background="gradient2"
                width="100%"
              >
                ยืนยัน
              </Button>
            </Flex>
          </Flex>
        </ContentContainer>
      </Modal>

      <ProgressBar status={1} />
      <Container>
        <div>
          <ContentContainer
            margin="1em 0"
            padding="12px 16px"
            paddingTablet="12px 16px"
            paddingMobile="12px 16px"
            bgcolor="newGrReverse"
            minHeight="0"
            width="100%"
          >
            <Typo.H6 textAlign="center">รายการสั่งซื้อในตะกร้า</Typo.H6>
          </ContentContainer>

          <TabelContainer
            cartData={cartData}
            handleRemove={handleRemove}
            configs={configs}
            go={go}
          />
          {deliverChannel === deliverChannels.online && (
            <CouponContainer
              myCoupon={myCoupon}
              selectedCoupon={selectedCoupon}
              handleSetSelectCoupon={handleSetSelectCoupon}
              go={go}
              isAdmin={profileState.admin}
            />
          )}
          <SummaryContainer
            configs={configs}
            cartData={cartData}
            deliverChannel={deliverChannel}
            selectedCoupon={selectedCoupon}
            profileState={profileState}
          />

          <div className="bg-white p-3 mt-3 rounded-lg shadow-md">
            {localStorage.guestId ||
            deliverChannel !== deliverChannels.online ? (
              <p className="font-semibold">ยืนยันข้อมูลผู้ซื้อ</p>
            ) : (
              <div className="grid grid-cols-2 gap-2 mb-3">
                <button
                  className={`${
                    !isBuyForSomeoneElse
                      ? "bg-gradient-to-r from-[#012E7D] to-[#1788D8] shadow-md"
                      : "bg-[#E5E7E9]"
                  } rounded-md py-2 font-semibold text-white disabled:opacity-55`}
                  onClick={() => {
                    setIsBuyForSomeoneElse(false);
                    setOrderBody((prevState) => ({
                      ...prevState,
                      buyFor: {},
                    }));
                  }}
                >
                  ซื้อให้ตัวเอง
                </button>
                <button
                  className={`${
                    isBuyForSomeoneElse
                      ? "bg-gradient-to-r from-[#012E7D] to-[#1788D8] shadow-md"
                      : "bg-[#E5E7E9]"
                  } rounded-md py-2 font-semibold text-white disabled:opacity-55`}
                  onClick={() => {
                    setIsBuyForSomeoneElse(true);
                  }}
                >
                  {sessionStorage.getItem("sendAsAGift")
                    ? "ส่งของขวัญ"
                    : "ซื้อให้บุคคลอื่น"}
                </button>
              </div>
            )}
            {isBuyForSomeoneElse ? (
              <div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">ชื่อ</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.firstName || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        buyFor: {
                          ...prevState.buyFor,
                          firstName: e.target.value,
                          accName:
                            e.target.value +
                            " " +
                            (prevState.buyFor?.lastName || ""),
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">นามสกุล</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.lastName || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        buyFor: {
                          ...prevState.buyFor,
                          lastName: e.target.value,
                          accName:
                            (prevState.buyFor?.firstName || "") +
                            " " +
                            e.target.value,
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">เบอร์โทรศัพท์</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.phone || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        buyFor: {
                          ...prevState.buyFor,
                          phone: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">
                    ธนาคารรับเงินรางวัล
                  </p>
                  <select
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.bank || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        buyFor: {
                          ...prevState.buyFor,
                          bank: e.target.value,
                        },
                      }))
                    }
                  >
                    {Object.values(bankList).map((bank, i) => (
                      <option key={i} value={bank}>
                        {bank}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">
                    เลขบัญชีรับเงินรางวัล
                  </p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.accNo || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        buyFor: {
                          ...prevState.buyFor,
                          accNo: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">
                    ชื่อบัญชีรับเงินรางวัล
                  </p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.buyFor?.accName || ""}
                    disabled={true}
                    // onChange={(e) =>
                    //   setOrderBody((prevState) => ({
                    //     ...prevState,
                    //     buyFor: {
                    //       ...prevState.buyFor,
                    //       accName: e.target.value,
                    //     },
                    //   }))
                    // }
                  />
                </div>
              </div>
            ) : (
              <div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">ชื่อ</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.firstName || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        firstName: e.target.value,
                        bank: {
                          ...prevState.bank,
                          accName: e.target.value + " " + prevState.lastName,
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">นามสกุล</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.lastName || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        lastName: e.target.value,
                        bank: {
                          ...prevState.bank,
                          accName: prevState.firstName + " " + e.target.value,
                        },
                      }))
                    }
                  />
                </div>
                <div className="">
                  <p className="text-sm mt-2 font-semibold">เบอร์โทรศัพท์</p>
                  <input
                    className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                    value={orderBody.phone || ""}
                    onChange={(e) =>
                      setOrderBody((prevState) => ({
                        ...prevState,
                        phone: e.target.value,
                      }))
                    }
                  />
                </div>
                {localStorage.guestId && (
                  <div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">
                        ธนาคารรับเงินรางวัล
                      </p>
                      <select
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.bank?.name || ""}
                        onChange={(e) =>
                          setOrderBody((prevState) => ({
                            ...prevState,
                            bank: {
                              ...prevState.bank,
                              name: e.target.value,
                            },
                          }))
                        }
                      >
                        {Object.values(bankList).map((bank, i) => (
                          <option key={i} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">
                        เลขบัญชีรับเงินรางวัลบัญชี
                      </p>
                      <input
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.bank.accNo || ""}
                        onChange={(e) =>
                          setOrderBody((prevState) => ({
                            ...prevState,
                            bank: {
                              ...prevState.bank,
                              accNo: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">
                        ชื่อบัญชีรับเงินรางวัล
                      </p>
                      <input
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.bank.accName || ""}
                        disabled={true}
                        // onChange={(e) =>
                        //   setOrderBody((prevState) => ({
                        //     ...prevState,
                        //     bank: {
                        //       ...prevState.bank,
                        //       accName: e.target.value,
                        //     },
                        //   }))
                        // }
                      />
                    </div>
                  </div>
                )}
                {deliverChannel === "mail" && (
                  <div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">ที่อยู่</p>
                      <input
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.address?.addr || ""}
                        onChange={(e) =>
                          setOrderBody((prevState) => ({
                            ...prevState,
                            address: {
                              ...prevState.address,
                              addr: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">จังหวัด</p>
                      <select
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.address?.province || ""}
                        onChange={(e) =>
                          setOrderBody((prevState) => ({
                            ...prevState,
                            address: {
                              ...prevState.address,
                              province: e.target.value,
                            },
                          }))
                        }
                      >
                        <option value=""></option>
                        {provinces.map((province) => (
                          <option key={province} value={province}>
                            {province}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="">
                      <p className="text-sm mt-2 font-semibold">เลขไปรษณีย์</p>
                      <input
                        className="border-1 w-full h-fit border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                        value={orderBody.address?.zipcode || ""}
                        onChange={(e) =>
                          setOrderBody((prevState) => ({
                            ...prevState,
                            address: {
                              ...prevState.address,
                              zipcode: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                    <div className="flex mt-3">
                      <span className="text-red-500 mr-1">*</span>
                      <p className="font-medium text-sm ">
                        ค่าจัดส่งใบแรก{" "}
                        {configs.shipping.prices.join(
                          ".00 บาท และใบต่อไปใบละ "
                        )}
                        .00 บาท{" "}
                      </p>
                    </div>
                    <div className="flex mt-1">
                      <span className="text-red-500 mr-1">*</span>
                      <p className="font-medium text-sm ">
                        ลูกค้าท่านใดที่สั่งซื้อสลากฯ ตั้งแต่วันที่{" "}
                        {roundDateToDate(configs.shipping.start)} -{" "}
                        {roundDateToDate(configs.shipping.end)} ที่มีความประสงค์
                        ต้องการให้บริษัทฯ จัดส่งสลากให้ท่าน
                        ท่านจะมีรอบจัดส่งรอบต่อไปในวันที่{" "}
                        {roundDateToDate(configs.shipping.send)}
                      </p>
                    </div>
                    <div className="flex mt-1">
                      <span className="text-red-500 mr-1">*</span>
                      <p className="font-medium text-sm ">
                        ทางบริษัทฯ ขอสงวนสิทธิ์
                        หากลูกค้าต้องการยกเลิกการจัดส่งใบสลากฯ
                        และท่านจะไม่ได้รับค่าจัดส่งคืนทุกกรณี
                      </p>
                    </div>
                    <div className="flex mt-1">
                      <span className="text-red-500 mr-1">*</span>
                      <p className="font-medium text-sm ">
                        หลังจากจัดส่งแล้ว
                        ทางหงษ์ทองจะให้หมายเลขพัสดุกับท่านภายใน 2
                        วันทำการของไปรษณีย์
                        หากสูญหายทางบริษัทจะไม่รับผิดชอบใดๆทั้งสิ้น
                        โดยทางลูกค้าต้องติดตามสถานะของพัสดุด้วยตนเอง
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
            {localStorage.guestId && (
              <div className="flex mt-3">
                <span className="text-red-500 mr-1">*</span>
                <p className="font-medium text-sm ">
                  กรณีถูกรางวัล หากท่านไม่กรอกข้อมูลบัญชีธนาคาร
                  ท่านจะไม่สามารถรับเงินรางวัลได้จนกว่าจะติดต่อให้ข้อมูลบัญชีธนาคารกับทางหงษ์ทอง
                </p>
              </div>
            )}
          </div>
          {/* policy */}
          <div className="bg-white p-3 mt-3 rounded-lg shadow-md">
            <p className="font-semibold">
              ข้อตกลงและเงื่อนไขในการซื้อลอตเตอรี่
            </p>
            <p className="text-sm text-gray-700 mt-3">
              ข้อตกลงและเงื่อนไขในการซื้อลอตเตอรี่หงษ์ทอง
              คือแพลตฟอร์มจำหน่ายลอตเตอรี่ออนไลน์
            </p>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>บริการระบบจัดหาลอตเตอรี่ด้วยระบบ โปรแกรมอัจฉริยะ</p>
            </div>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>
                บริการ แจ้งเตือนรายการสั่งซื้อไปยัง smร หรือ Line ของผู้สั่งซื้อ
              </p>
            </div>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>บริการ รับฝากลอตเตอรี่ (พร้อมประกันการ สูญหาย)</p>
            </div>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>บริการ รับฝากตรวจผลลอตเตอรี่</p>
            </div>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>บริการ แจ้งผลถูกรางวัลไปยัง รmร หรือ Line ของผู้สั่งซื้อ</p>
            </div>
            <div className="flex text-sm gap-2 mt-1">
              <p> &#x2022; </p>
              <p>บริการ รับขึ้นเงินรางวัล ภายใน 24-48 ชั่วโมง</p>
            </div>

            {!showConsent && (
              <p
                className="text-sm font-semibold mt-2 cursor-pointer"
                onClick={() => {
                  setShowConsent(true);
                }}
              >
                ...อ่านเพิ่มเติม
              </p>
            )}
            <Collapse isOpen={showConsent}>
              <p className="text-sm text-gray-700 mt-3">
                เงื่อนไขการขอรับต้นฉบับลอตเตอรี่
                หากลอตเตอรี่ของลูกค้าถูกรางวัลสามารถแจ้งความประสงค์เพื่อรับลอตเตอรี่ใบจริงเพื่อ
                นำไปขึ้นเงินด้วยตนเองได้หรือสามารถให้หงษ์ทองนำลอตเตอรี่ไปขึ้นเงินแทนลูกค้าเพื่อความสะดวกโดยจะไม่มีค่าธรรมเนียมการขึ้น
                เงินรางวัล และทางหงษ์ทองจะดำเนินการโอนเงินรางวัลให้ลูกค้า ภายใน
                24-48 ชั่วโมง หลังจากได้รับ SMS หรือ Line ยืนยันการ
                ถูกรางวัลจากทางหงษ์ทอง หากลอตเตอรี่ของลูกค้าไม่ถูกรางวัลในงวด
              </p>
              <p className="text-sm text-gray-700 mt-3">
                หงษ์ทองขอสงวนสิทธิ์ในการขอตรวจสอบอายุผู้ซื้อและฉันตกลงยอมจ่ายค่าปรับให้กับทางหงษ์ทองเป็นเงิน{" "}
                <span
                  style={{
                    color: themes.colors.red,
                    fontWeight: 600,
                  }}
                >
                  10,000 (หนึ่งหมื่นบาท ถ้วน)
                </span>{" "}
                ต่อการซื้อลอตเตอรี่ 1 ใบ ในกรณีที่หงษ์ทองตรวจพบว่า
                ฉันซื้อลอตเตอรี่ ในสถานศึกษา และหรืออายุฉันยังไม่ถึง 20
                ปีบริบูรณ์
              </p>
              <p className="text-sm text-gray-700 mt-3">
                ฉันตกลงและทราบดีว่าทางหงษ์ทองขอสงวนสิทธิ์ในการไม่โอนเงินรางวัลในกรณีผู้ซื้อถูกรางวัล
                และจะไม่คืนเงินค่าซื้อลอตเตอรี่ให้กับ ผู้ซื้อลอตเตอรี่
                ในกรณีที่หงษ์ทองตรวจพบว่า ผู้ซื้อมีอายุต่ำกว่า 20 ปีบริบูรณ์
              </p>
              <p className="text-sm text-gray-700 mt-3">
                กรุณากดปุ่มด้านล่างเพื่อรับรองว่าฉันไม่ได้ซื้อลอตเตอรี่ในสถานศึกษาและปัจจุบันฉันมีอายุครบ
                20 ปีบริบูรณ์
              </p>
            </Collapse>
            <button
              className="bg-[#DDF2E4] mt-3 w-full flex items-center justify-center gap-2 rounded-md text-[#1EA94C] font-bold py-2 disabled:bg-[#DDDDDD] disabled:text-slate-50"
              disabled={acceptConsent}
              onClick={() => {
                setAcceptConsent(true);
              }}
            >
              {acceptConsent && <FaCheck />} ข้าพเจ้ารับทราบและรับรอง
            </button>
          </div>
          <Grid margin="24px 0" columns={2}>
            <Button
              color="navy"
              onClick={() => go("/deliverChannel")}
              hoverBg="transparent"
              background="transparent"
            >
              <IoIosArrowBack
                style={{
                  color: themes.colors.navy,
                  marginRight: "7px",
                }}
              />
              {/* เปลี่ยนช่องทางการใช้บริการ */}
              ย้อนกลับ
            </Button>
            <Button
              disabled={
                !deliverChannel ||
                !acceptConsent ||
                !orderBody.firstName ||
                !orderBody.lastName ||
                !orderBody.phone
              }
              width="100%"
              hoverBg="transparent"
              hoverBorder="navy"
              hoverColor="navy"
              background="gradient2"
              onClick={() => createOrder()}
            >
              {/* <IoIosArrowForward className="ml-1" /> */} สร้างคำสั่งซื้อ
            </Button>
          </Grid>
        </div>
      </Container>
    </Flex>
  );
};

const CouponContainer = ({
  myCoupon,
  selectedCoupon,
  handleSetSelectCoupon,
  go,
  isAdmin,
}) => {
  if (myCoupon.length > 0)
    return (
      <ContentContainer
        className="flex flex-col w-full scroll"
        minHeight="0"
        padding="12px 16px"
        paddingTablet="12px 16px"
        paddingMobile="12px 16px"
      >
        <Typo.H7 color="textBlack" className="mb-3">
          คูปองและส่วนลด
        </Typo.H7>

        <CouponWrapper className="pb-3 my-1">
          {myCoupon.map((coup) => {
            return (
              <CouponCard
                key={coup.id}
                data={coup.coupon}
                isSelected={coup.id === selectedCoupon.id}
                handleSetSelectCoupon={handleSetSelectCoupon}
                orderId={coup.id}
              />
            );
          })}
        </CouponWrapper>

        <Button
          className="mt-3"
          background="lightNavy2"
          color="navy"
          width="100%"
          onClick={() => go("/coupon")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.285934 0.769556C-0.0954912 1.02096 -0.107866 1.62024 0.262889 1.88276C0.353804 1.94711 0.553784 1.95805 1.97911 1.97708C3.71012 2.00013 3.71298 2.00046 3.90141 2.23162C4.01653 2.37286 4.07428 2.66662 5.15976 8.6372C5.77202 12.0049 6.28352 14.8095 6.29644 14.8696C6.31718 14.9663 6.28792 14.9993 6.04383 15.1549C4.77993 15.9607 4.86903 17.8293 6.2052 18.5374C6.32097 18.5987 6.44406 18.649 6.47877 18.649C6.5264 18.6489 6.53426 18.6778 6.51089 18.7671C5.85507 21.2754 9.4486 22.4077 10.2481 19.9446C10.3244 19.7096 10.3259 18.9844 10.2504 18.8101C10.2196 18.7388 10.3942 18.7349 13.5787 18.7349C16.7631 18.7349 16.9377 18.7388 16.9069 18.8101C16.7667 19.1341 16.8561 19.9557 17.0716 20.3247C18.2425 22.3293 21.2674 21.0443 20.6402 18.8087C20.5738 18.5721 20.5738 18.5464 20.6402 18.4341C20.7387 18.2674 20.7339 17.889 20.6314 17.7335C20.4407 17.4443 21.0553 17.4695 13.6431 17.4458C7.03575 17.4246 6.93796 17.4231 6.79738 17.3384C6.38532 17.0901 6.38532 16.5125 6.79738 16.2642C6.9378 16.1796 7.03608 16.1779 13.1705 16.1564C17.7528 16.1403 19.4375 16.1213 19.5393 16.0846C20.1962 15.8472 20.6986 15.2762 20.8371 14.6099C20.9147 14.2361 22.0006 5.44285 22.0003 5.1904C21.9999 4.93597 21.913 4.76718 21.7151 4.63672C21.596 4.55812 21.3587 4.55576 13.6849 4.55548L5.77746 4.55515L5.55581 3.3413C5.21949 1.49908 4.95945 1.05677 4.04584 0.772856C3.6356 0.645366 0.478434 0.642616 0.285934 0.769556ZM20.5826 5.93153C20.5826 6.18607 19.5346 14.3513 19.4874 14.4646C19.4567 14.5383 19.3585 14.6543 19.2692 14.7223L19.1069 14.8462L13.3815 14.8579L7.65621 14.8695L7.63168 14.7504C7.61815 14.6849 7.25856 12.7074 6.83258 10.3559C6.40655 8.00448 6.04707 6.02739 6.03365 5.96238L6.00934 5.84424H13.296H20.5826V5.93153ZM9.30934 7.21484C9.00783 7.41361 9.02455 7.22953 9.02455 10.3559C9.02455 13.0409 9.02829 13.1761 9.10551 13.2932C9.3644 13.6859 9.97264 13.6859 10.2315 13.2932C10.3574 13.1023 10.3574 7.60963 10.2315 7.41867C10.0992 7.21803 9.93288 7.13388 9.66849 7.13388C9.5091 7.13388 9.39223 7.16023 9.30934 7.21484ZM13.2625 7.21484C12.961 7.41361 12.9777 7.22953 12.9777 10.3559C12.9777 13.0409 12.9814 13.1761 13.0586 13.2932C13.3175 13.6859 13.9258 13.6859 14.1846 13.2932C14.2619 13.1761 14.2656 13.0409 14.2656 10.3559C14.2656 7.67101 14.2619 7.53588 14.1846 7.41867C14.0523 7.21803 13.886 7.13388 13.6216 7.13388C13.4622 7.13388 13.3454 7.16023 13.2625 7.21484ZM17.1297 7.21484C16.8282 7.41361 16.8448 7.22953 16.8448 10.3559C16.8448 13.0409 16.8486 13.1761 16.9259 13.2932C17.1847 13.6859 17.7929 13.6859 18.0518 13.2932C18.129 13.1761 18.1328 13.0409 18.1328 10.3559C18.1328 7.67101 18.129 7.53588 18.0518 7.41867C17.9195 7.21803 17.7532 7.13388 17.4888 7.13388C17.3294 7.13388 17.2125 7.16023 17.1297 7.21484ZM8.69565 18.8594C9.21084 19.1991 8.99045 19.9804 8.37946 19.9804C8.03367 19.9804 7.77847 19.7251 7.77847 19.3794C7.77847 19.0336 8.03367 18.7784 8.37946 18.7784C8.49677 18.7784 8.62113 18.8103 8.69565 18.8594ZM19.0941 18.8594C19.2816 18.983 19.3789 19.1606 19.3789 19.3794C19.3789 19.5982 19.2816 19.7757 19.0941 19.8994C18.8341 20.0708 18.4423 19.9753 18.2578 19.6956C18.0865 19.4356 18.1819 19.0438 18.4617 18.8594C18.5362 18.8103 18.6606 18.7784 18.7779 18.7784C18.8952 18.7784 19.0195 18.8103 19.0941 18.8594Z"
              fill="#003A9E"
            />
          </svg>
          &nbsp;&nbsp; ซื้อคูปองเพิ่ม
        </Button>
      </ContentContainer>
    );
};

const SummaryContainer = ({
  configs,
  cartData,
  selectedCoupon,
  profileState,
}) => {
  return (
    <ContentContainer
      padding="12px 16px"
      paddingTablet="12px 16px"
      paddingMobile="12px 16px"
      minHeight="0"
    >
      <Typo.H7 color="textBlack" margin="0 0 15px 0">
        สรุปรายการทั้งหมด
      </Typo.H7>
      {cartData.length === 0 ? (
        <LoadingIcon />
      ) : (
        <>
          <Typo.Body2 color="navy" margin="0 0 0 0">
            ค่าลอตเตอรี่
          </Typo.Body2>
          <Flex align="center" justify="space-between">
            <Flex align="center">
              <Typo.Body1 color="textBlack">
                ใบละ {configs.price} บาท
              </Typo.Body1>
              &nbsp;&nbsp;
              <Typo.Body3 color="gray4">
                {" "}
                x &nbsp;{cartData?.totalSize} ใบ
              </Typo.Body3>
            </Flex>
            <Typo.Body3 lineHeight="15px" margin="0 10px 0 0" color="textBlack">
              {(configs.price * cartData.totalSize).toLocaleString()} บาท
            </Typo.Body3>
          </Flex>
          {/* //////////////////////  ONLINE  ////////////////////// */}
          {cartData.deliverChannel === deliverChannels.online &&
            !profileState.is80Privilage && (
              <>
                <Typo.Body2 color="navy" margin="15px 0 0 0">
                  ค่าบริการฝากลอตเตอรี่
                </Typo.Body2>
                <Flex align="center" justify="space-between">
                  <Flex align="center">
                    <Typo.Body1 color="textBlack">
                      ใบละ {configs.fee} บาท
                    </Typo.Body1>
                    &nbsp;&nbsp;
                    <Typo.Body3 color="gray4">
                      x &nbsp;{cartData.totalSize} ใบ
                    </Typo.Body3>
                  </Flex>
                  <Typo.Body3
                    lineHeight="15px"
                    margin="0 10px 0 0"
                    color="textBlack"
                  >
                    {(cartData.totalSize * configs.fee).toLocaleString()} บาท
                  </Typo.Body3>
                </Flex>
              </>
            )}
          {/* //////////////////////  MAIL  ////////////////////// */}
          {cartData.deliverChannel === deliverChannels.mail && (
            <>
              <Typo.Body2 color="navy" margin="15px 0 0 0">
                ค่าจัดส่ง
              </Typo.Body2>
              <Flex align="center" justify="space-between">
                <Flex align="center">
                  <Typo.Body1 color="textBlack">
                    ใบแรก {configs.shipping.prices[0]} บาท ใบต่อไปใบละ{" "}
                    {configs.shipping.prices[1]} บาท
                  </Typo.Body1>
                  &nbsp;&nbsp;
                  <Typo.Body3 color="gray4">
                    {" "}
                    x &nbsp;{cartData?.totalSize} ใบ
                  </Typo.Body3>
                </Flex>
                <Typo.Body3
                  lineHeight="15px"
                  margin="0 10px 0 0"
                  color="textBlack"
                >
                  {cartData.totalShippingPrice?.toLocaleString()} บาท
                </Typo.Body3>
              </Flex>
            </>
          )}
          {/* //////////////////////  CONTAIN SPECIAL PRICE  ////////////////////// */}
          {cartData?.calPrice?.filter((data) => data.specialNumberFee !== 0)
            .length != 0 && (
            <>
              <Typo.Body2 color="navy" margin="15px 0 0 0">
                ค่าเลขพิเศษ
              </Typo.Body2>
              {cartData?.calPrice
                ?.filter((data) => data.specialNumberFee !== 0)
                .map((specialLotto, index) => {
                  return (
                    <Flex key={index} align="center" justify="space-between">
                      <Flex align="center">
                        <Typo.Body1 color="textBlack">
                          {specialLotto.number.toString().includes("magicBlock")
                            ? `${specialLotto.number.split("-")[1]}`
                            : specialLotto.number}{" "}
                          ใบละ{" "}
                          {specialLotto.specialNumberFee / specialLotto.size}{" "}
                          บาท
                        </Typo.Body1>
                        &nbsp;&nbsp;
                        <Typo.Body3 color="gray4">
                          {" "}
                          x &nbsp;{specialLotto.size} ใบ
                        </Typo.Body3>
                      </Flex>
                      <Typo.Body3
                        lineHeight="15px"
                        margin="0 10px 0 0"
                        color="textBlack"
                      >
                        {specialLotto.specialNumberFee?.toLocaleString()} บาท
                      </Typo.Body3>
                    </Flex>
                  );
                })}
            </>
          )}
          {/* //////////////////////  SELECT COUPON  ////////////////////// */}
          {selectedCoupon.coupon && (
            <>
              <Typo.Body2 color="navy" margin="15px 0 0 0">
                คูปองและส่วนลด
              </Typo.Body2>
              <Flex align="center" justify="space-between">
                <Flex align="center">
                  <Typo.Body1 color="textBlack">
                    {selectedCoupon?.coupon?.name}
                  </Typo.Body1>
                  &nbsp;&nbsp;
                </Flex>
                <Typo.Body3 lineHeight="15px" margin="0 10px 0 0" color="green">
                  -{cartData.discount} บาท
                </Typo.Body3>
              </Flex>
            </>
          )}
          <Line border={`2px solid ${themes.colors.gray2}`} />
          <Flex align="center" justify="space-between">
            <Typo.Body1 color="textBlack">รวมเป็นเงินทั้งสิ้น</Typo.Body1>
            <Flex align="center" gap="10px">
              {cartData?.discount !== 0 && cartData?.discount && (
                <s style={{ lineHeight: "15px" }}>
                  {cartData?.totalPrice?.toLocaleString()} บาท
                </s>
              )}
              <Typo.H5 lineHeight="15px" margin="0 10px 0 0" color="red">
                {(
                  cartData?.totalPrice - cartData?.discount || 0
                ).toLocaleString()}{" "}
                บาท
              </Typo.H5>
            </Flex>
          </Flex>
        </>
      )}
    </ContentContainer>
  );
};

const TabelContainer = ({ cartData, handleRemove, configs, go }) => {
  return (
    <ContentContainer
      padding="12px"
      paddingTablet="12px"
      paddingMobile="12px"
      minHeight="0"
    >
      <Typo.H7 color="textBlack">รายการลอตเตอรี่</Typo.H7>
      <Flex margin="24px 0" align="center" gap="8px">
        <img src="/images/logo_single.png" alt="logo_single" width="40px" />
        <Typo.Body1 color="textBlack">หงษ์ทอง ลอตเตอรี่ออนไลน์</Typo.Body1>
      </Flex>
      {cartData.length === 0 ? (
        <LoadingIcon />
      ) : (
        <div>
          {cartData?.calPrice?.map((lotto, i) => (
            <OrderWrap
              key={i}
              lottos={lotto}
              handleRemove={handleRemove}
              configs={configs}
            />
          ))}
        </div>
      )}
      <Button
        background="lightNavy2"
        color="navy"
        width="100%"
        margin="2em 0 0 0"
        onClick={() => go("/search")}
      >
        {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.285934 0.769556C-0.0954912 1.02096 -0.107866 1.62024 0.262889 1.88276C0.353804 1.94711 0.553784 1.95805 1.97911 1.97708C3.71012 2.00013 3.71298 2.00046 3.90141 2.23162C4.01653 2.37286 4.07428 2.66662 5.15976 8.6372C5.77202 12.0049 6.28352 14.8095 6.29644 14.8696C6.31718 14.9663 6.28792 14.9993 6.04383 15.1549C4.77993 15.9607 4.86903 17.8293 6.2052 18.5374C6.32097 18.5987 6.44406 18.649 6.47877 18.649C6.5264 18.6489 6.53426 18.6778 6.51089 18.7671C5.85507 21.2754 9.4486 22.4077 10.2481 19.9446C10.3244 19.7096 10.3259 18.9844 10.2504 18.8101C10.2196 18.7388 10.3942 18.7349 13.5787 18.7349C16.7631 18.7349 16.9377 18.7388 16.9069 18.8101C16.7667 19.1341 16.8561 19.9557 17.0716 20.3247C18.2425 22.3293 21.2674 21.0443 20.6402 18.8087C20.5738 18.5721 20.5738 18.5464 20.6402 18.4341C20.7387 18.2674 20.7339 17.889 20.6314 17.7335C20.4407 17.4443 21.0553 17.4695 13.6431 17.4458C7.03575 17.4246 6.93796 17.4231 6.79738 17.3384C6.38532 17.0901 6.38532 16.5125 6.79738 16.2642C6.9378 16.1796 7.03608 16.1779 13.1705 16.1564C17.7528 16.1403 19.4375 16.1213 19.5393 16.0846C20.1962 15.8472 20.6986 15.2762 20.8371 14.6099C20.9147 14.2361 22.0006 5.44285 22.0003 5.1904C21.9999 4.93597 21.913 4.76718 21.7151 4.63672C21.596 4.55812 21.3587 4.55576 13.6849 4.55548L5.77746 4.55515L5.55581 3.3413C5.21949 1.49908 4.95945 1.05677 4.04584 0.772856C3.6356 0.645366 0.478434 0.642616 0.285934 0.769556ZM20.5826 5.93153C20.5826 6.18607 19.5346 14.3513 19.4874 14.4646C19.4567 14.5383 19.3585 14.6543 19.2692 14.7223L19.1069 14.8462L13.3815 14.8579L7.65621 14.8695L7.63168 14.7504C7.61815 14.6849 7.25856 12.7074 6.83258 10.3559C6.40655 8.00448 6.04707 6.02739 6.03365 5.96238L6.00934 5.84424H13.296H20.5826V5.93153ZM9.30934 7.21484C9.00783 7.41361 9.02455 7.22953 9.02455 10.3559C9.02455 13.0409 9.02829 13.1761 9.10551 13.2932C9.3644 13.6859 9.97264 13.6859 10.2315 13.2932C10.3574 13.1023 10.3574 7.60963 10.2315 7.41867C10.0992 7.21803 9.93288 7.13388 9.66849 7.13388C9.5091 7.13388 9.39223 7.16023 9.30934 7.21484ZM13.2625 7.21484C12.961 7.41361 12.9777 7.22953 12.9777 10.3559C12.9777 13.0409 12.9814 13.1761 13.0586 13.2932C13.3175 13.6859 13.9258 13.6859 14.1846 13.2932C14.2619 13.1761 14.2656 13.0409 14.2656 10.3559C14.2656 7.67101 14.2619 7.53588 14.1846 7.41867C14.0523 7.21803 13.886 7.13388 13.6216 7.13388C13.4622 7.13388 13.3454 7.16023 13.2625 7.21484ZM17.1297 7.21484C16.8282 7.41361 16.8448 7.22953 16.8448 10.3559C16.8448 13.0409 16.8486 13.1761 16.9259 13.2932C17.1847 13.6859 17.7929 13.6859 18.0518 13.2932C18.129 13.1761 18.1328 13.0409 18.1328 10.3559C18.1328 7.67101 18.129 7.53588 18.0518 7.41867C17.9195 7.21803 17.7532 7.13388 17.4888 7.13388C17.3294 7.13388 17.2125 7.16023 17.1297 7.21484ZM8.69565 18.8594C9.21084 19.1991 8.99045 19.9804 8.37946 19.9804C8.03367 19.9804 7.77847 19.7251 7.77847 19.3794C7.77847 19.0336 8.03367 18.7784 8.37946 18.7784C8.49677 18.7784 8.62113 18.8103 8.69565 18.8594ZM19.0941 18.8594C19.2816 18.983 19.3789 19.1606 19.3789 19.3794C19.3789 19.5982 19.2816 19.7757 19.0941 19.8994C18.8341 20.0708 18.4423 19.9753 18.2578 19.6956C18.0865 19.4356 18.1819 19.0438 18.4617 18.8594C18.5362 18.8103 18.6606 18.7784 18.7779 18.7784C18.8952 18.7784 19.0195 18.8103 19.0941 18.8594Z"
              fill="#003A9E"
            />
          </svg>
        }{" "}
        &nbsp;&nbsp; ซื้อลอตเตอรี่เพิ่ม
      </Button>
    </ContentContainer>
  );
};

const OrderWrap = ({ lottos, handleRemove, configs }) => {
  return (
    <div className="relative mt-4">
      {[...Array(lottos.size)].map((lotto, index) => {
        return (
          <div
            className={`relative flex items-center bg-white p-3 border border-gray-500 rounded-lg  mb-2`}
            key={index}
          >
            <div
              onClick={() => handleRemove(lottos?.number)}
              className="w-fit flex justify-end cursor-pointer mr-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
              >
                <path
                  className=" fill-red-500"
                  d="M6 1C6 0.447715 6.44772 0 7 0H11C11.5523 0 12 0.447715 12 1V2H17C17.5523 2 18 2.44772 18 3C18 3.55228 17.5523 4 17 4H1C0.447716 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H6V1Z"
                />
                <path
                  className="fill-red-500"
                  d="M3 6C3.55228 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H13C13.5523 18 14 17.5523 14 17V7C14 6.44772 14.4477 6 15 6C15.5523 6 16 6.44772 16 7V17C16 18.6569 14.6569 20 13 20H5C3.34315 20 2 18.6569 2 17V7C2 6.44772 2.44772 6 3 6Z"
                />
                <path
                  className="fill-red-500"
                  d="M6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9V15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V9Z"
                />
                <path
                  className="fill-red-500"
                  d="M11 8C10.4477 8 10 8.44772 10 9V15C10 15.5523 10.4477 16 11 16C11.5523 16 12 15.5523 12 15V9C12 8.44772 11.5523 8 11 8Z"
                />
              </svg>
            </div>
            <p className="font-medium flex-grow pt-1">
              {lottos.number?.toString().includes("magicBlock")
                ? `${lottos?.number.split("-")[1]} (${
                    configs.magicNumber.name
                  })`
                : lottos.number?.toString().includes("labubuBlock")
                ? `${lottos?.number} (เลขลาบูบู้)`
                : lottos.number}{" "}
              <span className="opacity-40"> x 1 ใบ</span>
            </p>

            <p className="font-semibold text-right min-w-20 pt-1">
              {lottos?.numberTotalPrice / lottos.size} บาท
            </p>
          </div>
        );
      })}
    </div>
  );
};

const CouponWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  width: 100%;
  white-space: nowrap;
  gap: 15px;

  overflow: auto;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    -webkit-appearance: none;

    height: 10px !important;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(245, 194, 64, 1);
    border-radius: 10px;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5); */
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    border-radius: 10px;
    margin: ${(props) => props.padding || "20px 20px"};
  }

  @media only screen and (${devices.tablet}) {
    padding: ${(props) => props.paddingTablet || props.padding || 0};
    ::-webkit-scrollbar-track {
      margin: ${(props) => props.paddingTablet || "20px 20px"};
    }
  }

  @media only screen and (max-width: 510px) {
    padding: ${(props) => props.paddingMobile || 0};
    ::-webkit-scrollbar-track {
      margin: ${(props) => props.paddingMobile || "20px 20px"};
    }
  }
`;
